module.exports = __webpack_public_path__ + "img/wxkf.24f07768.png";